import { CopyServiceModal } from './CopyServiceModal.main';

export { CopyServiceModal };
